import React, { useEffect, useState } from 'react';
import axiosInstance from '../request';
import { URL } from '../api';

const EmployeeView = () => {
  const [originalEmployee, setOriginalEmployee] = useState(null);
  const [employee, setEmployee] = useState({
    userId: '',
    userName: '',
    email: '',
    phoneNumber: '',
    dept: '',
    isActive: '1',
    address: '',
    name: '',
    groupId: '',
    password: '',
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.split('?')[1]);
    const userId = params.get('UserId');
    if (userId) {
      fetchEmployee(userId);
    }
  }, []);

  const fetchEmployee = async (userId) => {
    try {
      const res = await axiosInstance.get(`${URL.EMPLOYEE_LIST}?userId=${userId}`);
      if (res.data && res.data.length > 0) {
        const emp = res.data[0];
        const fetchedData = {
          userId: emp.user_id,
          userName: emp.user_name,
          email: emp.email,
          phoneNumber: emp.phone_number,
          dept: emp.dept,
          isActive: emp.is_active.toString(),
          address: emp.address || '',
          name: emp.name,
          groupId: emp.group_id || '',
          password: '',
        };
        setEmployee(fetchedData);
        setOriginalEmployee(fetchedData);
      }
    } catch (err) {
      console.error('Failed to fetch employee:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployee((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = { userId: parseInt(employee.userId) };

    Object.keys(employee).forEach((key) => {
      if (key === 'userId') return;
      const originalValue = originalEmployee?.[key] ?? '';
      const currentValue = employee[key];

      if (key === 'password') {
        if (currentValue.trim() !== '') {
          payload[key] = currentValue;
        }
      } else if (String(originalValue) !== String(currentValue)) {
        payload[key] = key === 'isActive' || key === 'groupId' ? parseInt(currentValue) : currentValue;
      }
    });

    try {
      await axiosInstance.post(URL.EDIT_EMPLOYEE, payload);
      alert('Employee updated successfully');
    } catch (err) {
      console.error('Update failed:', err);
      alert('Failed to update employee');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="card shadow-sm p-4">
      <h4 className="mb-3">Edit User</h4>

      <div className="row g-3">
        <div className="col-md-6">
          <label><strong>Name</strong></label>
          <input type="text" name="name" value={employee.name} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-6">
          <label><strong>Email</strong></label>
          <input type="email" name="email" value={employee.email} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-6">
          <label><strong>Phone</strong></label>
          <input type="text" name="phoneNumber" value={employee.phoneNumber} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-6">
          <label><strong>Department</strong></label>
          <input type="text" name="dept" value={employee.dept} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-12">
          <label><strong>Address</strong></label>
          <textarea name="address" value={employee.address} onChange={handleChange} className="form-control" rows="2" />
        </div>

        <div className="col-md-6">
          <label><strong>Username</strong></label>
          <input type="text" name="userName" value={employee.userName} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-6">
          <label><strong>Password</strong></label>
          <input
            type="password"
            name="password"
            value={employee.password}
            onChange={handleChange}
            className="form-control"
            placeholder="••••••••"
          />
        </div>

        <div className="col-md-6">
          <label><strong>Status</strong></label>
          <select name="isActive" value={employee.isActive} onChange={handleChange} className="form-select">
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </div>

        <div className="col-md-6">
          <label><strong>Group ID</strong></label>
          <input type="number" name="groupId" value={employee.groupId} onChange={handleChange} className="form-control" />
        </div>

        <div className="col-12 mt-3">
          <button type="submit" className="btn btn-success">
            Update Employee
          </button>
        </div>
      </div>
    </form>
  );
};

export default EmployeeView;